import { formatter as currencyFormatter } from '@zoopla/shared/currency';

type Props = {
    areaName?: string | null | undefined;
    averagePricePaid?: number;
    noindex?: boolean;
    path?: string;
    schema: () => string;
};

export const getPricesHead = (props: Props) => {
    const { areaName, averagePricePaid, noindex, path, schema } = props;

    const avgPrice = averagePricePaid
        ? currencyFormatter.format(averagePricePaid)
        : undefined;

    const pageTitle = areaName
        ? `House prices in ${areaName} - sold prices and estimates - Zoopla`
        : 'House Prices - Zoopla';

    const descriptionCopy =
        'Get a free instant estimate for your property online and find more UK property prices.';

    const pageDescription = () => {
        if (areaName && avgPrice) {
            return `The average sold house price in ${areaName} is ${avgPrice}. ${descriptionCopy}`;
        }
        if (areaName && !avgPrice) {
            return `Find average sold house prices in ${areaName} for the last 12 months. ${descriptionCopy}`;
        }
        return 'Find average house prices, current average values, other historic property data & request a valuation from an estate agent.';
    };

    return {
        canonicalPath: `/house-prices${path ? `/${path}` : ''}/`,
        pageTitle: pageTitle,
        pageDescription: pageDescription(),
        index: () => (noindex ? false : true),
        schema: schema
    };
};
